import React, { Component, useEffect, useRef, useState } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  StatusBar,
  ScrollView,
  Alert,
  Platform,
  ImageBackground,
  FlatList,
} from "react-native";
import * as Linking from "expo-linking";
import Icon from "react-native-vector-icons/FontAwesome";
import IconIonic from "react-native-vector-icons/Ionicons";
import * as Notifications from "expo-notifications";
import Constants from "expo-constants";

import styles from "./styles";
import {
  adicionarToken,
  candidatarVaga,
  dispensarVaga,
  getAluno,
  listarVagas,
  listarVagasPublicas,
} from "../../services/aluno-service";
import Toast from "react-native-tiny-toast";
import { EventRegister } from "react-native-event-listeners";

import ConfirmarDados from "../../components/ConfirmarDados";
import CardVaga from "../../components/CardVaga";
import CardVagaMural from "../../components/CardVagaMural";
import colors from "../../styles/colors";
import { LinearGradient } from "expo-linear-gradient";
import { api } from "../../services/api";
import AsyncStorage from "@react-native-community/async-storage";

Notifications.setNotificationHandler({
  handleNotification: async () => ({
    shouldShowAlert: true,
    shouldPlaySound: false,
    shouldSetBadge: false,
  }),
});

const EvolucaoPerfil = ({ navigate, reloadEvolucao }) => {
  const [aluno, setAluno] = useState({});

  const [loading, setLoading] = useState(true);

  StatusBar.setBarStyle("light-content");

  useEffect(() => {
    const carregaAluno = async () => {
      setAluno(await getAluno(true));
      setLoading(false);
    };
    carregaAluno();
  }, [reloadEvolucao]);

  const temTelefoneVerificado = (telefones) => {
    let encontrouVerificado = false;

    telefones &&
      telefones.forEach((t) => {
        if (t.verificado) encontrouVerificado = true;
      });
    return encontrouVerificado;
  };

  const navegar = (target) => {
    navigate("InformarRedeSocial", {
      aluno,
      target,
      cameFromHome: true,
    });
  };

  const hasLinkedin = () => !!aluno.linkedin && aluno.linkedin !== "";
  const hasFacebook = () => !!aluno.facebook && aluno.facebook !== "";
  const hasInstagram = () => !!aluno.instagram && aluno.instagram !== "";
  const hasLinkCurriculo = () =>
    !!aluno.link_curriculo && aluno.link_curriculo !== "";

  console.log(hasLinkedin());

  return (
    <View style={[styles.personalData, { marginTop: 0 }]}>
      <View style={styles.header}>
        <Text style={styles.textHeader}>Complete o seu perfil</Text>
      </View>
      <View style={styles.body}>
        {loading ? (
          <Text style={{ color: colors.text }}>Carregando...</Text>
        ) : (
          <View style={[styles.containerProgresso, { paddingBottom: 0 }]}>
            {temTelefoneVerificado(aluno.telefones) && (
              <View style={[styles.linhaProgresso, { paddingTop: 0 }]}>
                <View style={[styles.pontoOk, { marginTop: -2 }]}></View>
                <View style={{ marginLeft: 10, flexDirection: "row" }}>
                  <Icon
                    name="phone-square"
                    size={30}
                    color="green"
                    style={{ marginLeft: 5 }}
                  />
                  {hasLinkedin() && (
                    <Icon
                      name="linkedin"
                      size={30}
                      color="green"
                      style={{ marginLeft: 10 }}
                    />
                  )}
                  {hasFacebook() && (
                    <Icon
                      name="facebook-square"
                      size={30}
                      color="green"
                      style={{ marginLeft: 10 }}
                    />
                  )}
                  {hasInstagram() && (
                    <Icon
                      name="instagram"
                      size={30}
                      color="green"
                      style={{ marginLeft: 10 }}
                    />
                  )}
                  {hasLinkCurriculo() && (
                    <Icon
                      name="user"
                      size={30}
                      color="green"
                      style={{ marginLeft: 10 }}
                    />
                  )}
                </View>
              </View>
            )}
            {temTelefoneVerificado(aluno.telefones) &&
              hasLinkedin() &&
              hasFacebook() &&
              hasInstagram() &&
              hasLinkCurriculo() && (
                <View style={styles.linhaProgresso}>
                  <View
                    style={[styles.pontoOk, { alignSelf: "flex-end" }]}
                  ></View>
                  <Text style={styles.textoOk}>
                    Perfil ok! Lembre-se de manter atualizado.
                  </Text>
                </View>
              )}
            {!temTelefoneVerificado(aluno.telefones) && (
              <View style={styles.linhaProgresso}>
                <View
                  style={
                    aluno.telefones && temTelefoneVerificado(aluno.telefones)
                      ? styles.pontoOk
                      : styles.pontoNok
                  }
                ></View>
                <Text style={styles.textoOk}>Telefone Verificado</Text>
              </View>
            )}
            {!hasLinkedin() && (
              <View style={styles.linhaProgresso}>
                <View
                  style={hasLinkedin() ? styles.pontoOk : styles.pontoNok}
                ></View>
                <TouchableOpacity
                  onPress={() => navegar("linkedin")}
                  disabled={hasLinkedin() ? true : false}
                  hitSlop={{ top: 10, bottom: 10, left: 80, right: 40 }}
                >
                  <Text
                    style={hasLinkedin() ? styles.textoOk : styles.textoNok}
                  >
                    {hasLinkedin()
                      ? "Linkedin Adicionado"
                      : "Adicionar Linkedin"}
                  </Text>
                </TouchableOpacity>
              </View>
            )}
            {!hasFacebook() && (
              <TouchableOpacity
                onPress={() => navegar("facebook")}
                disabled={aluno.facebook ? true : false}
                hitSlop={{ top: 10, bottom: 10, left: 80, right: 40 }}
              >
                <View style={styles.linhaProgresso}>
                  <View
                    style={aluno.facebook ? styles.pontoOk : styles.pontoNok}
                  ></View>
                  <Text
                    style={aluno.facebook ? styles.textoOk : styles.textoNok}
                  >
                    {aluno.facebook
                      ? "Facebook Adicionado"
                      : "Adicionar Facebook"}
                  </Text>
                </View>
              </TouchableOpacity>
            )}
            {!hasInstagram() && (
              <View style={[styles.linhaProgresso, { paddingBottom: 0 }]}>
                <View
                  style={aluno.instagram ? styles.pontoOk : styles.pontoNok}
                ></View>
                <TouchableOpacity
                  onPress={() => navegar("instagram")}
                  disabled={aluno.instagram ? true : false}
                  hitSlop={{ top: 10, bottom: 10, left: 80, right: 40 }}
                >
                  <Text
                    style={aluno.instagram ? styles.textoOk : styles.textoNok}
                  >
                    {aluno.instagram
                      ? "Instagram Adicionado"
                      : "Adicionar Instagram"}
                  </Text>
                </TouchableOpacity>
              </View>
            )}
            {!hasLinkCurriculo() && (
              <View style={[styles.linhaProgresso, { paddingBottom: 0 }]}>
                <View
                  style={
                    aluno.link_curriculo ? styles.pontoOk : styles.pontoNok
                  }
                ></View>
                <TouchableOpacity
                  onPress={() => navigate("EditarDadosProfissionais")}
                  disabled={aluno.link_curriculo ? true : false}
                  hitSlop={{ top: 10, bottom: 10, left: 80, right: 40 }}
                >
                  <Text
                    style={
                      aluno.link_curriculo ? styles.textoOk : styles.textoNok
                    }
                  >
                    {aluno.link_curriculo
                      ? "Perfil Atualizado"
                      : "Atualizar Perfil"}
                  </Text>
                </TouchableOpacity>
              </View>
            )}
          </View>
        )}

        <Text style={[styles.alert, { marginTop: 10 }]}>
          Nós pedimos as suas redes sociais somente para fins de contato.
        </Text>
        <Text style={styles.alert}>
          Seus dados só serão compartilhados com as vagas que você se
          candidatar.
        </Text>
      </View>
    </View>
  );
};

const NovasVagas = ({ mostrarConfirm, vagas, loading, navigation }) => {
  return (
    <>
      <View style={styles.header}>
        <Text style={styles.textHeader}>Vagas vinculadas</Text>
      </View>
      <View style={styles.body}>
        {loading ? (
          <Text style={{ fontFamily: "Montserrat", color: colors.text }}>
            Carregando...
          </Text>
        ) : vagas.novas.length === 0 ? (
          <Text
            style={{
              fontFamily: "Montserrat",
              textAlign: "center",
              color: "#C1C1C1",
            }}
          >
            As vagas direcionadas ao seu perfil aparecerão aqui.
          </Text>
        ) : (
          vagas.novas.map((v) => (
            <CardVaga
              key={v.id}
              vaga={v}
              mostrarConfirm={() => mostrarConfirm(v.id)}
              irParaDetalhes={() => navigation.push("Vaga", { vaga: v })}
            />
          ))
        )}
      </View>
    </>
  );
};

const VagasPublicas = ({
  mostrarConfirm,
  vagas,
  vagasPrivadas,
  loading,
  navigation,
}) => {
  return (
    <>
      <View style={styles.header}>
        <Text style={styles.textHeader}>Mural de Vagas</Text>
      </View>
      <View style={styles.body}>
        {loading ? (
          <Text style={{ fontFamily: "Montserrat", color: colors.text }}>
            Carregando...
          </Text>
        ) : vagas.length < 1 ? (
          <Text
            style={{
              fontFamily: "Montserrat",
              textAlign: "center",
              color: "#C1C1C1",
            }}
          >
            As vagas públicas aparecerão aqui.
          </Text>
        ) : (
          <FlatList
            horizontal
            data={vagas}
            keyExtractor={(vaga) => String(vaga.id)}
            showsVerticalScrollIndicator={false}
            renderItem={(vaga) => {
              // let ids = vagasPrivadas.candidatadas.map((c) => c.id);
              // ids = [...ids, ...vagasPrivadas.novas.map((c) => c.id)];
              // if (ids.includes(vaga.item.id)) return null;
              return (
                <CardVagaMural
                  key={vaga.item.id}
                  vaga={vaga.item}
                  mostrarConfirm={() => mostrarConfirm(vaga.item.id)}
                  irParaDetalhes={() =>
                    navigation.push("Vaga", { vaga: vaga.item })
                  }
                />
              );
            }}
          />
          // vagas.map((v) => (
          // <CardVaga
          //   key={v.id}
          //   vaga={v}
          //   mostrarConfirm={() => mostrarConfirm(v.id)}
          //   irParaDetalhes={() => navigation.push("Vaga", { vaga: v })}
          // />
          // ))
        )}
      </View>
    </>
  );
};

function Home({ navigation }) {
  const [idModalConfirm, setIdModalConfirm] = useState(0);
  let [reloadEvolucao, setReloadEvolucao] = useState(0);
  const [vagas, setVagas] = useState({
    novas: [],
    candidatadas: [],
  });
  const [vagasPublicas, setVagasPublicas] = useState([]);

  const notificationListener = useRef();
  const responseListener = useRef();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const temTelefoneValidado = async () => {
      const { telefones } = await getAluno(true);

      let encontrouVerificado = false;

      telefones.forEach((t) => {
        if (t.verificado) encontrouVerificado = true;
      });

      if (!encontrouVerificado) navigation.replace("SemTelefoneVerificado");
    };

    const buscarVagas = async () => {
      setLoading(true);
      try {
        const response = await listarVagas();

        const responsePublicas = await listarVagasPublicas();

        if (!response.ok) return console.log(await response.json());
        if (!responsePublicas.ok)
          return console.log(await responsePublicas.json());

        let vagasPrivadasAux = await response.json();
        let vagasPublicasAux = await responsePublicas.json();

        //pegar todos os ids das vagas privadas do usuário
        let ids = vagasPrivadasAux.candidatadas.map((c) => c.id);
        ids = [...ids, ...vagasPrivadasAux.novas.map((c) => c.id)];

        setVagas(vagasPrivadasAux);

        //retira do mural as vagas públicas que já tenha vínculo
        setVagasPublicas(vagasPublicasAux.filter((v) => !ids.includes(v.id)));

        setLoading(false);
      } catch (e) {
        console.error(e);
      }
    };

    const listener = EventRegister.addEventListener(
      "reloadHome",
      async (data) => {
        setReloadEvolucao(Math.random());
        await buscarVagas();
      }
    );

    const listenerCandidatura = EventRegister.addEventListener(
      "reloadCandidaturas",
      (vagaId) => {
        buscarVagas();
      }
    );

    temTelefoneValidado();
    buscarVagas();

    registerForPushNotificationsAsync().then(async (token) => {
      const tokenSent = await AsyncStorage.getItem("tokenSent");

      if (!tokenSent) {
        adicionarToken(token);

        AsyncStorage.setItem("tokenSent", "true");
      }
    });

    notificationListener.current =
      Notifications.addNotificationReceivedListener((notification) => {
        console.log("recebeu a notificação", notification);
      });

    responseListener.current =
      Notifications.addNotificationResponseReceivedListener((response) => {
        console.log("clicou na notificação");

        console.log(response);
      });

    return function limpar() {
      //limpar eventlisteners
      EventRegister.removeEventListener(listener);
      EventRegister.removeEventListener(listenerCandidatura);

      //limpar notificações
      Notifications.removeNotificationSubscription(
        notificationListener.current
      );
      Notifications.removeNotificationSubscription(responseListener.current);
    };
  }, []);

  const candidatarSe = async () => {
    try {
      const response = await candidatarVaga(idModalConfirm);

      if (!response.ok) return console.log(await response.json());

      setVagas({
        ...vagas,
        novas: vagas.novas.filter((v) => v.id != idModalConfirm),
      });

      EventRegister.emit("reloadCandidaturas", idModalConfirm);

      setVagasPublicas(vagasPublicas.filter((v) => v.id != idModalConfirm));

      setIdModalConfirm(0);

      Toast.show("Candidatura Realizada. Aguarde o contato da empresa.");
    } catch (e) {
      console.error(e);
    }
  };

  const dispensar = async (vagaId) => {
    try {
      const response = await dispensarVaga(vagaId);

      if (!response.ok) return console.log(await response.json());

      setIdModalConfirm(0);

      Toast.show("Vaga dispensada.");

      EventRegister.emit("reloadHome");

      navigation.pop(1);
    } catch (e) {
      console.error(e);
    }
  };

  const handleRedes = (target) => {
    Linking.openURL(target);
  };

  return (
    <>
      {idModalConfirm !== 0 && (
        <ConfirmarDados
          fechar={() => setIdModalConfirm(0)}
          dispensar={() => {
            if (
              Platform.OS === "web" &&
              window.confirm("Deseja realmente dispensar essa oportunidade?")
            )
              dispensar(idModalConfirm);
            else
              Alert.alert(
                "Confirmar",
                "Deseja realmente dispensar essa oportunidade?",
                [
                  {
                    text: "Sim",
                    onPress: () => dispensar(idModalConfirm),
                  },
                  {
                    text: "Não",
                    style: "cancel",
                  },
                ]
              );
          }}
          confirmar={candidatarSe}
        />
      )}
      <ImageBackground
        source={require("../../../resources/imgs/bg.jpg")}
        style={[styles.container]}
        imageStyle={styles.imageContainer}
      >
        <ScrollView style={[{ paddingVertical: 10, height: 100 }]}>
          <EvolucaoPerfil
            navigate={navigation.navigate}
            reloadEvolucao={reloadEvolucao}
          />
          <View style={[styles.personalData]}>
            <NovasVagas
              vagas={vagas}
              loading={loading}
              mostrarConfirm={setIdModalConfirm}
              navigation={navigation}
            />
          </View>
          <View style={[styles.personalData]}>
            <VagasPublicas
              vagas={vagasPublicas}
              loading={loading}
              vagasPrivadas={vagas}
              mostrarConfirm={setIdModalConfirm}
              navigation={navigation}
            />
          </View>
          <View style={[styles.personalData, { marginBottom: 30 }]}>
            <View style={styles.header}>
              <Text style={styles.textHeader}>Siga a gente nas redes</Text>
            </View>
            <View style={styles.body}>
              <View
                style={{
                  flexDirection: "row",
                  marginHorizontal: 30,
                  justifyContent: "space-between",
                  backgroundColor: "#F000",
                }}
              >
                <Icon
                  name="linkedin"
                  size={45}
                  color="#0e76a8"
                  style={{ marginLeft: 10 }}
                  onPress={() =>
                    handleRedes(
                      "https://www.linkedin.com/school/senai-jandira/"
                    )
                  }
                />
                <Icon
                  name="facebook-square"
                  size={45}
                  color="#3b5998"
                  style={{ marginLeft: 10 }}
                  onPress={() =>
                    handleRedes("https://facebook.com/senaijandira")
                  }
                />
                <LinearGradient
                  start={[0, 1]}
                  end={[1, 0]}
                  colors={[
                    "#f09433",
                    "#e6683c",
                    "#dc2743",
                    "#cc2366",
                    "#bc1888",
                  ]}
                  style={[
                    styles.buttonEntry,
                    {
                      paddingHorizontal: 6,
                      borderWidth: 0,
                      borderRadius: 10,
                      alignItems: "center",
                      justifyContent: "center",
                    },
                  ]}
                >
                  <Icon
                    name="instagram"
                    size={40}
                    color="#FFF"
                    onPress={() =>
                      handleRedes("https://www.instagram.com/senaijandira/")
                    }
                  />
                </LinearGradient>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  marginTop: 20,
                  marginHorizontal: 30,
                  justifyContent: "space-between",
                  backgroundColor: "#F000",
                }}
              >
                <Icon
                  name="youtube"
                  size={45}
                  color="#c4302b"
                  style={{ marginLeft: 10 }}
                  onPress={() =>
                    handleRedes(
                      "https://www.youtube.com/channel/UCQTDY9m19yZ9aoUWFpxmfIw"
                    )
                  }
                />
                <Icon
                  name="twitter"
                  size={45}
                  color="#00ACEE"
                  style={{ marginLeft: 10 }}
                  onPress={() =>
                    handleRedes("https://twitter.com/senaijandira")
                  }
                />
                <IconIonic
                  name="globe"
                  size={45}
                  color="#FFF"
                  style={{ marginLeft: 10 }}
                  onPress={() => handleRedes("https://jandira.sp.senai.br/")}
                />
              </View>
            </View>
          </View>
        </ScrollView>
      </ImageBackground>
    </>
  );
}

async function registerForPushNotificationsAsync() {
  let token;
  if (Constants.isDevice && Platform.OS !== "web") {
    const { status: existingStatus } =
      await Notifications.getPermissionsAsync();
    let finalStatus = existingStatus;
    if (existingStatus !== "granted") {
      const { status } = await Notifications.requestPermissionsAsync();
      finalStatus = status;
    }
    if (finalStatus !== "granted") {
      alert(
        "Falha ao gerar o token de notificação, verifique as suas configurações de notificações"
      );

      return;
    }
    token = (await Notifications.getExpoPushTokenAsync()).data;
  }

  if (Platform.OS === "android") {
    Notifications.setNotificationChannelAsync("default", {
      name: "default",
      importance: Notifications.AndroidImportance.MAX,
      vibrationPattern: [0, 250, 250, 250],
      lightColor: "#FF231F7C",
    });
  }

  return token;
}

Home.navigationOptions = ({ navigation }) => {
  return {
    headerTitle: "Home",
    headerStyle: {
      backgroundColor: "#0F0F0F",
    },
    headerTitleStyle: {
      color: "#FFF",
    },
    headerLeft: () => (
      <TouchableOpacity
        onPress={() => {
          navigation.openDrawer();
        }}
      >
        <Icon
          style={styles.iconHeaderLeft}
          name="reorder"
          size={30}
          color="#F1F1F1"
        />
      </TouchableOpacity>
    ),
    headerRight: () => (
      <TouchableOpacity
        onPress={() => {
          EventRegister.emitEvent("reloadHome");
        }}
      >
        <Icon
          style={[styles.iconBarRight, { marginRight: 10 }]}
          name="refresh"
          size={20}
          color="#F1F1F1"
        />
      </TouchableOpacity>
    ),
  };
};

export default Home;
